<template>
  <div>
    <div :class="['appointment_item flex flex-vertical-center', {'not_task': !isNextAppointment}]">
      <div class="flex-grow">
        <p v-if="isNextAppointment" class="next_appointment">NEXT APPOINTMENT <strong v-html="appointmentDate"></strong></p>

        <h3
          class="appointment_item--title"
          @click="editAppointment(appointment)">{{ appointment.title }}</h3>

        <template v-if="!isNextAppointment">
          <p class="appointment_item--detail">
            <span class="appointment_item--detail--label">Date</span> <span v-html="appointmentDate"></span>
          </p>
          <p class="appointment_item--detail">
            <span class="appointment_item--detail--label">Location</span> {{ appointment.location }}
          </p>
        </template>

        <template v-if="appointment.description">
          <p class="appointment_item--detail">
            <button-link
              @click="manageDescription"
            >
              {{ !isShowDescription ? 'show' : 'hide' }} description
            </button-link>
          </p>

          <div v-show="isShowDescription" class="appointment_item--detail content mt-3 mb-2 ml-2" v-html="appointment.description"></div>
        </template>
      </div>

      <div>
        <app-avatar
          v-for="user in users"
          :key="user.id"
          :user-id="user.id"></app-avatar>
      </div>
    </div>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import {MODELS} from "../../../services/models";
import dates from "../../../services/dates";

export default {
  name: "AppointmentItem",
  props: {
    appointment: {
      type: Object,
      required: true
    },
    isNextAppointment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowDescription: false
    }
  },
  computed: {
    users() {
      return this.appointment.attendees
      .filter(a => a.class_name === MODELS.User.class_name);
    },
    appointmentDate() {
      const startTime = dates.formatAsTime(this.appointment.start_at);
      const endTime = dates.formatAsTime(this.appointment.end_at);
      const date = dates.formatAsDate(this.appointment.start_at);

      if(this.appointment.canceled_at) {
        const cancelledBy = this.$utils.newGetEnumLabel(this.appointment.canceled_type, ENUMS.AppointmentCancellationTypeEnum);
        return `<del>${date} at ${startTime} to ${endTime}</del> <small>(cancelled by ${cancelledBy})</small>`;
      }

      return `${date} at ${startTime} to ${endTime}`
    }
  },
  methods: {
    editAppointment(appointment) {
      this.$emit('edit', appointment);
    },
    manageDescription() {
      this.isShowDescription = !this.isShowDescription
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.next_appointment {
  margin: 8px 0 -4px;
  color: $text-muted;
  line-height: 1.3;

  @media all and (max-width: 1600px) {
    strong {
      display: block;
    }
  }
}

.appointment_item {

  &--title {
    margin: 0.5rem 0;
    color: $secondary;
    font-size: 1.125rem;
    line-height: 1.2;
    cursor: pointer;

    &:hover {
      color: $primary;
    }
  }

  &.not_next {
    margin-bottom: 0.75rem;
  }

  &--detail {
    margin-bottom: 0.25rem;
    font-size: 0.875rem;

    &--label {
      display: inline-block;
      width: 8ch;
    }
  }
}

</style>
